import { render, staticRenderFns } from "./SnackNotification.vue?vue&type=template&id=906b7f9c"
import script from "./SnackNotification.vue?vue&type=script&lang=js"
export * from "./SnackNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports